import { DateFormatOptions, DefaultDateTransformer, Locale } from '@jsverse/transloco-locale';

export class CustomDateTransformer extends DefaultDateTransformer {
  public override transform(date: Date, locale: Locale, options: DateFormatOptions): string {
    // if using english locale and setting a time
    // replace the locale to irish to display "a.m/p.m" instead of "am/pm"
    if (locale == 'en-GB' && options.timeStyle != undefined) {
      return new Intl.DateTimeFormat('en-IE', {
        dateStyle: options.dateStyle,
        timeStyle: options.timeStyle,
        hour12: true,
      })
        .format(date)
        .toString();
    }
    return super.transform(date, locale, options);
  }
}
